import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Inject,
  ViewChild,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { take } from 'rxjs';
import { ModalHeaderComponent } from '../modals/modal-header/modal-header.component';
import { LargeImageNavigatorDialogData } from './large-image-navigator.model';

@Component({
  selector: 'mh-large-image-navigator',
  templateUrl: './large-image-navigator.component.html',
  styleUrls: ['./large-image-navigator.component.scss'],
  host: { 'data-automation-id': 'large-image-navigator-modal' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LargeImageNavigatorComponent implements AfterViewInit {
  @ViewChild(ModalHeaderComponent) private readonly modalHeader?: ModalHeaderComponent;

  ngAfterViewInit(): void {
    this.dialogRef.afterOpened().pipe(take(1)).subscribe(() => {
      // Wait for the dialog animation so the focus-triggered tooltip uses its final position.
      this.modalHeader?.focusCloseButton();
    });
  }

  @HostListener('document:keydown.escape', ['$event'])
  onKeydownHandler(event: KeyboardEvent): void {
    const tooltip = document.querySelector('[role="tooltip"]');
    if (!tooltip) {
      this.dialogRef.close();
    }
  }

  src: string = this.data.src;
  alt: string = this.data.alt ?? '';
  credit: string = this.data.credit ?? '';

  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly data: LargeImageNavigatorDialogData,
    public readonly dialogRef: MatDialogRef<LargeImageNavigatorComponent>,
  ) {}
}
